module.exports = __webpack_public_path__ + "img/up-cadou-paste.dbd0b1ce.png";